import { render, staticRenderFns } from "./aFormSubmission.vue?vue&type=template&id=344c4df6&scoped=true&"
import script from "./aFormSubmission.vue?vue&type=script&lang=js&"
export * from "./aFormSubmission.vue?vue&type=script&lang=js&"
import style0 from "./aFormSubmission.vue?vue&type=style&index=0&id=344c4df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c4df6",
  null
  
)

export default component.exports